/**
 * Cumulative-bankroll curve. A thin wrapper over the shared `TrendChart` so it
 * shares the exact design language of the skills trajectory (gradient area
 * fill, endpoint dot, value + date axis labels) — DRY, one chart component.
 *
 * Differences from the skill chart, all via props: the value is money (so
 * `clamp={null}` for an unbounded domain + a `$` formatter) and a dashed zero
 * line marks break-even since a bankroll curve crosses it.
 */

import type { BankrollPoint } from "@/shared/models";
import { TrendChart } from "@/shared/components/TrendChart";
import { money } from "@/features/tracker/lib/trackerFormat";

export function BankrollChart({ series }: { series: BankrollPoint[] }) {
  return (
    <TrendChart
      points={series.map((p) => ({ date: p.at, value: p.cumulative }))}
      height={120}
      showAxis
      showZeroLine
      clamp={null}
      formatValue={money}
      ariaLabel="Cumulative bankroll over time"
      emptyLabel="Log a couple of sessions to see your bankroll curve."
    />
  );
}
